import axios from "axios";
import * as Yup from "yup";
// import { delay } from "../../../utils";
import { IWizardScreenElement } from "../../wizard/types";

export interface IPrimaryContact {
  firstName: string;
  lastName: string;
  phone: string;
  mobile: string;
  fax?: string;
}

export interface IOrganisation {
  organisationName: string;
  address: string;
  abn: string;
  userName: string;
}

export interface IVicFormsRegistrationData {
  person: IPrimaryContact;
  group: IOrganisation;
}

export const primaryContactValidation: Yup.SchemaOf<IPrimaryContact> =
  Yup.object().shape({
    fax: Yup.string(),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    mobile: Yup.string()
      .mobile("A valid mobile is required")
      .required("A mobile is required"),
    phone: Yup.string().required("Phone is required"),
  });

export const organisationValidation: Yup.SchemaOf<IOrganisation> =
  Yup.object().shape({
    organisationName: Yup.string().required("Organisation name is required"),
    userName: Yup.string()
      .required("Email is required")
      .email("A valid email is required")
      .test("test-id", "Usename is already in use", async (value, ...rest) => {
        if (!value) {
          return true;
        }
        return await validateUsername(value);
      }),
    address: Yup.string().required("Address is required"),
    abn: Yup.string()
      .required("ABN is required")
      .matches(/^(\d *?){11}$/, "A valid ABN is required"),
  });

export enum VicFormsRegistrationScreens {
  ORGANISATION = "ORGANISATION",
  PRIMARY_CONTACT = "PRIMARY_CONTACT",
  SUCCESS = "SUCCESS",
}

export interface VicFormsRegistrationWizardData {
  [VicFormsRegistrationScreens.ORGANISATION]: IOrganisation;
  [VicFormsRegistrationScreens.PRIMARY_CONTACT]: IPrimaryContact;
  [VicFormsRegistrationScreens.SUCCESS]: {};
}

export type VicFormsRegistrationScreenComponent = IWizardScreenElement<
  IPrimaryContact,
  VicFormsRegistrationWizardData,
  VicFormsRegistrationScreens
>;

async function validateUsername(value: string) {
  try {
    await axios.get(
      `${
        process.env.REACT_APP_VICFORMS_API_URL
      }/api/hutly/public/accounts/validate?email=${encodeURIComponent(value)}`,
      {
        headers: {

        },
      }
    );
    return true;
  } catch (e) {
    return false;
  }
}
